import React, { useState } from 'react';
import BaseModal from 'src/components/modals/BaseModal/BaseModal';
import PartnerCard from 'src/components/PartnerCard/PartnerCard';
import { Partner, PartnersByAccessTypeCode } from 'src/types/partner';
import TabList from 'src/components/buttons/TabList/TabList';
import { AccessType, AccessTypeCode } from 'src/types/accessType';
import { FunctionComponentReturnType } from 'src/types/sharedReact';
import CenteredWrapper from 'src/containers/CenteredWrapper/CenteredWrapper';
import { PathParameters } from 'src/utils/routing/RouteBuilder';
import './PartnerSwitchModal.css';
import { access } from 'fs';
import { CLIENT_PATHS } from 'src/utils/routing/routes';

type PartnerLinkClientBuilder = ({
    accessTypeCode,
    partnerCode
}: PathParameters) => string;

interface PartnerSwitchModalProps {
    isOpen: boolean;
    onClose: () => void;
    accessTypes: AccessType[];
    partners: PartnersByAccessTypeCode;
    clientBuilder?: PartnerLinkClientBuilder;
    onPartnerSelect?: (partner: Partner) => void;
}

function PartnerSwitchModal({
    isOpen,
    onClose,
    partners,
    accessTypes,
    clientBuilder,
    onPartnerSelect
}: PartnerSwitchModalProps): FunctionComponentReturnType {
    const [selectedAccessType, setSelectedAccessType] = useState<AccessTypeCode>(accessTypes[0].code);
    const partnersFromSelectedAccessType: Partner[] = (partners && partners[selectedAccessType]) || [];

    function onAccessTypeChange(value: AccessTypeCode): void {
        setSelectedAccessType(value);
    }

    const id = 'partner-cards-wrapper';

    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            title="Select Partner"
            description=""
            className="partner-switch-modal"
        >
            <TabList
                controlledPanelId={id}
                label="Access Type"
                values={accessTypes}
                onChange={onAccessTypeChange}
                selectedValue={selectedAccessType}
                alignment="center"
            />
            <CenteredWrapper id={id} className="partner-switch-grid">
                {
                    partnersFromSelectedAccessType.map((partner, i) => {
                        if (onPartnerSelect) {
                            return (
                                <div
                                    key={i}
                                    onClick={() => {
                                        onPartnerSelect(partner);
                                        onClose();
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <PartnerCard
                                        partner={partner}
                                        linkTo={CLIENT_PATHS.HOME_PAGE_V2}
                                    />
                                </div>
                            );
                        }
                        return <PartnerCard
                            key={i}
                            partner={partner}
                            linkTo={clientBuilder!({
                                accessTypeCode: partner.type,
                                partnerCode: partner.code
                            })}
                        />;
                    })
                }
            </CenteredWrapper>
        </BaseModal>
    );
}

export default PartnerSwitchModal;